var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-table',{attrs:{"data":_vm.data,"show-expand":_vm.showExpand,"expanded":_vm.expanded},scopedSlots:_vm._u([{key:"expanded-item",fn:function({ headers, item }){return [_c('td',{staticClass:"pa-0",attrs:{"colspan":headers.length}},[_c('raffle-winners',{attrs:{"url":item.raffle_winners_url}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }